<template>
  <div class="content">
    <div class="title">{{obj.title}}</div>
    <div class="createTime">时间：{{obj.createTime}}</div>
    <p class="source">来源：{{obj.source}}</p>
    <div v-html="content"></div>

    <div class="comment" v-if="obj.commentFlag==1">
      <p class="title">发表评论</p>
      <a-textarea size="large" placeholder="发表您的评论" v-model="value" :rows="4" />
      <div class="clearfix">
        <!-- 上传图片 -->
        <a-upload
          :action="action"
          multiple
          list-type="picture-card"
          :beforeUpload="handlebeforeUpload"
          :file-list="fileList"
          @preview="handlePreview"
          @change="handleChange"
        >
          <div v-if="fileList.length < 3">
            <a-icon type="plus" />
            <div class="ant-upload-text">上传图片</div>
          </div>
        </a-upload>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
          <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
        <a-button :disabled="value.length<=0" size="large" type="primary" @click="submit">发表</a-button>
      </div>

      <!-- 评论 -->
      <p class="title pt">评论列表（{{total}}条）</p>
      <div class="list">
        <div class="listt_box" v-for="(i,index) in list" :key="index">
          <p class="name">{{i.nickName}}</p>
          <p class="newcontent">{{i.content}}</p>
          <imgs :list="i.imgs" @click="Onclick" />
          <div class="addcomment" v-if="i.more">
            <a-textarea size="large" :placeholder="i.placeHolder" v-model="i.value" :rows="3" />
          </div>

          <div class="bottom">
            <div class="flex">
              <span>{{i.createTime | replyTime}}</span>
              <span
                class="visible"
                v-if="sysUser.id==i.memberId&&!i.more"
                @click="delComment(true,i.id,index)"
              >
                <a-icon type="delete" />删除
              </span>
            </div>
            <template v-if="i.more">
              <div>
                <a-button
                  style="margin-right:15px;"
                  :disabled="i.value.length<=0"
                  size="large"
                  type="primary"
                  @click="clickSave(i,i.id,i.id)"
                >确认回复</a-button>
                <a-button
                  style="margin-right:15px;"
                  size="large"
                  type="primary"
                  @click="i.more = false;i.value=''"
                >取消</a-button>
              </div>
            </template>
            <span v-else style="margin-right:15px;" @click="openInput(i)">
              <a-icon type="form" />回复
            </span>
          </div>

          <template v-if="i.children.length>0">
            <div class="replay" v-for="(item,num) in i.children" :key="num">
              <p class="name">{{item.nickName}}</p>
              <p class="newcontent" v-html="item.content+getObject(item.replyToComment)"></p>
              <div class="addcomment" v-if="item.more">
                <a-textarea
                  size="large"
                  :placeholder="item.placeHolder"
                  v-model="item.value"
                  :rows="3"
                />
              </div>
              <div class="bottom">
                <div class="flex">
                  <span>{{item.createTime | replyTime}}</span>
                  <span
                    class="visible"
                    v-if="sysUser.id==item.memberId&&!item.more"
                    @click="delComment(false,item.id,index,num)"
                  >
                    <a-icon type="delete" />删除
                  </span>
                </div>
                <template v-if="item.more">
                  <div>
                    <a-button
                      style="margin-right:15px;"
                      v-if="item.more"
                      :disabled="item.value.length<=0"
                      size="large"
                      type="primary"
                      @click="clickSave(item,i.id,item.id)"
                    >确认回复</a-button>
                    <a-button
                      style="margin-right:15px;"
                      size="large"
                      type="primary"
                      @click="item.more = false"
                    >取消</a-button>
                  </div>
                </template>
                <span
                  v-else
                  style="margin-right:15px;"
                  @click="openInput(0,false,{index,list:item})"
                >
                  <a-icon type="form" />回复
                </span>
              </div>
            </div>
          </template>

          <div class="btn">
            <div v-if="i.replyCount!=0" @click="addMore(index)">
              查看剩下{{i.replyCount}}条回复
              <a-icon type="down-circle" />
            </div>
            <div v-if="i.replyCount==0&&i.replycount!=0" @click="clearAll(index)">
              收起
              <a-icon type="up-circle" />
            </div>
          </div>
        </div>
      </div>
      <div class="lookmore" v-if="moreShow" @click="loadAdd">
        <p v-if="!loadmore">查看更多</p>
        <div v-else class="load"></div>
      </div>
      <div :class="{'mask':true,'maskShow':show,'overstory':show}" @click="show = false">
        <img :src="imgUrl" @click.stop />
      </div>
    </div>
  </div>
</template>
<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
import {
  getArticleDetail,
  getCommentNum,
  getPageList,
  save,
  getReplyPageList,
  delComment,
} from "@/api/news";
import { ls } from "@/utils/tool.js";
import imgs from "@/views/news-bulletin/components/imgs.vue";
export default {
  components: {
    imgs,
  },
  data() {
    return {
      obj: {},
      content: "",
      id: this.$route.params.id,
      pageNum: 1,
      pageSize: 10,
      replypageSize: 10,
      total: 0,
      list: [],
      value: "",
      fileList: [],
      action: this.base_url + "/api/file/upload",
      previewVisible: false,
      previewImage: "",
      show: false,
      imgUrl: "",
      sysUser: ls.get("sysUser"),
      loadmore: false,
      moreShow: true,
    };
  },
  created() {
    this.getCommentNum();
    this.getPageList();
  },
  mounted() {
    this.init();
  },
  methods: {
    // 打开遮罩层
    Onclick(i) {
      this.imgUrl = i;
      this.show = true;
    },
    async init() {
      var res = await getArticleDetail(this.id);
      this.obj = res.data;
      console.log("res.data===", res.data);
      this.content =
        res.data.content.replace(/src="\.\./g, 'src="' + this.base_url) || "";
      this.content = this.content.replace(
        /width="300" height="150">/g,
        `controls width="100%">`
      );
    },
    // 提交
    async submit() {
      let req = {
        articleId: this.id,
        content: this.value,
      };
      if (this.fileList.length > 0) {
        let str = "";
        this.fileList.forEach((i) => {
          str += i.response.data + ",";
        });
        req.imgs = str.substring(0, str.length - 1);
      }
      let res = await save(req);
      if (res.code == 200) {
        this.$message.success("评论成功");
        this.value = "";
        return;
      }
      this.$message.warning(res.message);
    },
    // 回复打开输入框
    openInput(i, type = true, l) {
      if (type) {
        this.list.forEach((item) => {
          item.placeHolder = `回复${i.nickName}:`;
          item.more = false;
        });
        i.more = true;
        return;
      }
      this.list[l.index].children.forEach((item) => {
        item.placeHolder = `回复${item.nickName}:`;
        item.more = false;
      });
      l.list.more = true;
    },
    async addMore(index) {
      let item = this.list[index];
      item.pageNum++;
      let data = {
        articleId: this.id,
        firstReplyId: item.id,
        pageNum: item.pageNum,
        pageSize: this.replypageSize,
      };
      let res = await getReplyPageList(data);
      res.data.list.forEach((i) => {
        i.more = false;
        i.value = "";
      });

      this.list[index].children = [...item.children, ...res.data.list];
      let num = item.replyCount - res.data.list.length;
      this.list[index].replyCount = num < 0 ? 0 : num;
    },
    //获取评论总数
    async getCommentNum() {
      var res = await getCommentNum(this.id);
      this.total = res.data;
    },
    //获取一级评论列表
    async getPageList() {
      let opt = {
        articleId: this.id,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      var res = await getPageList(opt);
      res.data.list.forEach((i) => {
        i.children = [];
        i.pageNum = 0;
        i.more = false;
        i.value = "";
        i.replycount = i.replyCount;
        i.imgs = this.getimgsList(i.imgs);
      });
      this.pageNum++;
      if (res.data.list.length < this.pageSize) {
        this.moreShow = false;
      }
      this.list = [...this.list, ...res.data.list];
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
    },
    handlebeforeUpload() {
      console.log("上传前", this.fileList);
      if (this.fileList.length >= 3) {
        console.log(this.fileList);
        return false;
      }
      return true;
    },
    //删除评论
    delComment(type, i, fir, sec) {
      let that = this;
      this.$confirm({
        title: "删除提示",
        content: "请问是否删除该评论？",
        async onOk() {
          let res = await delComment(i);
          if (res.code == 200) {
            // that.total--;
            that.getCommentNum();
            if (type) {
              that.list.splice(fir, 1);
            } else {
              that.list[fir].children.splice(sec, 1);
            }
          }
        },
        onCancel() {},
      });
    },
    // 确认回复
    async clickSave(item, firstReplyId, pid) {
      let req = {
        articleId: this.id,
        content: item.value,
        firstReplyId,
        pid,
      };
      let res = await save(req);
      if (res.code == 200) {
        this.$message.success("回复成功");
        item.value = "";
        item.more = false;
        return;
      }
      this.$message.warning("回复失败，请稍后再试");
    },
    getObject(obj) {
      if (obj) {
        return `   //<span style='color:blue;cursor:pointer;'>@${obj.nickName}</span>： ${obj.content}`;
      }
      return "";
    },
    async loadAdd() {
      this.loadmore = true;
      this.getPageList();
      this.loadmore = false;
    },
    // 清除所有二级评论
    clearAll(index) {
      this.list[index].children = [];
      this.list[index].pageNum = 0;
      this.list[index].replyCount = this.list[index].replycount;
    },
    // 处理图片文字格式
    getimgsList(val) {
      let arr = [];
      if (val) {
        val.split(",").forEach((i) => {
          arr.push(this.base_url + i);
        });
      }
      return arr;
    },
  },
};
</script>
<style scoped lang='less'>
.content {
  width: 1200px;
  margin: 0 auto;
  color: black;
  > .title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }
  .createTime,
  .source {
    font-size: 14px;
    color: #666;
  }

  .comment {
    .title {
      padding: 10px 0;
      font-size: 20px;
      font-weight: 800;
    }
    .pt {
      padding-top: 40px;
    }
    .clearfix {
      margin-top: 15px;
      display: flex;
      align-items: flex-end;
    }
    .lookmore {
      padding: 20px 0;
      cursor: pointer;
      user-select: none;
      text-align: center;
      color: #626675;
      background: #f5f5f6;
      display: flex;
      align-items: center;
      justify-content: center;
      > p {
        margin: 0;
      }
      .load {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 5px solid #ccc;
        border-top: 4px solid #3ce1e2;
        animation: 1s load infinite linear;
      }
    }
    .list {
      padding: 10px 0;
      // background: #f2f2f2;
      // border-radius: 30px;
      font-size: 18px;
      .imgs {
        img {
          width: 150px;
          height: 150px;
        }
      }
      .listt_box {
        cursor: default;
        padding: 20px 0;
        .newcontent {
          padding: 15px 0;
        }
        .addcomment {
          padding: 15px 0;
        }
        p {
          margin: 0;
        }
        .replay {
          padding-top: 15px;
          > * {
            padding-left: 80px;
          }
        }
        .btn {
          padding: 15px 0 15px 80px;
          // border-bottom: 1px solid #ccc;
          div {
            cursor: pointer;
          }
        }
        .name {
          font-size: 22px;
          font-weight: 800;
          span {
            font-size: 10px;
            font-weight: 0;
            display: inline-block;
            margin-left: 15px;
            // transform: scale(0.95);
          }
        }
        .bottom {
          padding-bottom: 10px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          &:hover {
            .flex {
              span {
                visibility: visible;
              }
            }
          }
          .flex {
            flex: 1;
            span {
              color: #9195a3;
            }
          }
          p {
            font-size: 12px;
            margin: 0;
          }
          span {
            cursor: pointer;
            display: inline-block;
          }
        }
      }
    }
  }
  .maskShow {
    opacity: 1;

    img {
      width: 40%;
    }
  }
  .overstory {
    z-index: 1000;
  }
  .visible {
    display: inline-block;
    margin-left: 15px;
    visibility: hidden;
  }
}

.mask {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: -1;
  transition: all 0.5s;
  user-select: none;
  img {
    width: 0;
    transition: all 0.5s;
  }
}
@keyframes load {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>